import analyticsRust from "../../analyticsRust";

const Filters = ({ timeFilter, setTimeFilter, price, options, priceDirection, url }) => {
    let _price = parseFloat(price)?.toFixed(2);
    _price = String(price);
    let priceAfterDot = _price.split(".")[1];

    if (priceAfterDot) {
        if (priceAfterDot.length === 1) {
            priceAfterDot = priceAfterDot + "0";
        }
    }

    return (
        <div className="qx-widget-more-section">
            <div className="qx-widget-expand-icon flex ">
                <span style={{ marginRight: "2px" }} className="flex items-center">
                    {options.currency === "inr" && "₹"}
                    {options.currency === "usd" && "$"}
                    {options.currency === "q" && (
                        <svg
                            style={{ marginRight: "3px" }}
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M17.4791 16.1741C17.2922 16.4144 17.0884 16.6457 16.8676 16.8664C16.6462 17.0878 16.4142 17.2921 16.1733 17.4794L13.897 15.2033L11.835 17.2652L13.3877 18.8179C10.9812 19.395 8.34025 18.7445 6.46208 16.8664C3.58867 13.9932 3.58867 9.33483 6.46208 6.46163C9.33548 3.58842 13.9942 3.58842 16.8676 6.46163C18.7465 8.3404 19.3968 10.9825 18.8185 13.3896L17.2647 11.8359L15.2026 13.8978L17.4791 16.1741ZM20.5396 19.2345C20.3414 19.4664 20.1325 19.6924 19.9131 19.9117C19.6931 20.1317 19.4665 20.3411 19.234 20.5398L20.6323 21.9381L18.5702 24L16.7399 22.1698C12.3959 24.2681 7.02049 23.5154 3.41655 19.9117C-1.13885 15.3567 -1.13885 7.9714 3.41655 3.41632C7.97196 -1.13877 15.3577 -1.13877 19.9131 3.41632C23.5177 7.02066 24.2701 12.397 22.1702 16.7411L23.9999 18.5707L21.9378 20.6326L20.5396 19.2345Z"
                                fill="white"
                            ></path>
                        </svg>
                    )}
                    {`${_price.split(".")[0]}`}
                    <span
                        style={
                            priceDirection === "up" ? { color: "#25CA83" } : { color: "#F34860" }
                        }
                    >
                        .{`${priceAfterDot.substring(0, 2) || "00"}`}
                    </span>
                    {priceDirection === "up" ? (
                        <svg
                            width="12"
                            height="10"
                            viewBox="0 0 10 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M5 0L0.669872 6.75H9.33013L5 0Z" fill="#25ca83" />
                        </svg>
                    ) : (
                        <svg
                            width="12"
                            height="10"
                            viewBox="0 0 10 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M5 7L0.669872 0.25H9.33013L5 7Z" fill="#f34860" />
                        </svg>
                    )}
                </span>
            </div>
            <div className="qx-widget-filters">
                {/* <li
                    onClick={() => setTimeFilter("1h")}
                    className={timeFilter === "1h" ? "active" : ""}
                >
                    1H
                </li> */}
                <li
                    onClick={() => {
                        setTimeFilter("6h");

                        analyticsRust.graphEvent({
                            articleUrl: url,
                            subtype: "click",
                            price,
                            element: "timeChange",
                        });
                    }}
                    className={timeFilter === "6h" ? "active" : ""}
                >
                    6H
                </li>
                <li
                    onClick={() => {
                        setTimeFilter("1d");

                        analyticsRust.graphEvent({
                            articleUrl: url,
                            subtype: "click",
                            price,
                            element: "timeChange",
                        });
                    }}
                    className={timeFilter === "1d" ? "active" : ""}
                >
                    1D
                </li>
                <li
                    onClick={() => {
                        setTimeFilter("30d");

                        analyticsRust.graphEvent({
                            articleUrl: url,
                            subtype: "click",
                            price,
                            element: "timeChange",
                        });
                    }}
                    className={timeFilter === "30d" ? "active" : ""}
                >
                    1M
                </li>
            </div>
        </div>
    );
};

export default Filters;
